import React from "react";
import PropTypes from "prop-types";

/**
 * The medicines section's empty state — ONE of it, for both views.
 *
 * The New view has had the designed one (medallion, title, sentence) since it
 * shipped; the Old view answered with a bare line of grey text, which read as
 * an error rather than as "there is nothing here" (Nittin, 2026-09-24). They
 * are the same section and the same question, so they are now the same
 * component — a copy in each file is how the two drift apart again.
 *
 * Lives in its own module rather than being exported from Medicines.js because
 * OldMedicines is imported BY Medicines: exporting it there and importing it
 * back would be a cycle, and a cycle that only bites at module-init time is a
 * bad trade for one small component.
 */

/* Grey calendar-with-check medallion — the "no entries yet" glyph the mock
   uses for every variant of this state. */
export const EmptyCalendarIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 3.5v3M16 3.5v3M3.5 9.5h17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M9 14.5l2.2 2.2L15.5 12.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MedicinesEmpty = ({ title, body, children }) => (
  <div className="med3-empty">
    <span className="med3-empty-icon" aria-hidden="true">
      <EmptyCalendarIcon />
    </span>
    <p className="med3-empty-title">{title}</p>
    <span className="med3-empty-body">{body}</span>
    {children}
  </div>
);

MedicinesEmpty.propTypes = {
  title: PropTypes.node.isRequired,
  /** One sentence saying what to do about it, not just that it is empty. */
  body: PropTypes.node.isRequired,
  /** The action, where there is one — the Old view is read-only, so it has none. */
  children: PropTypes.node,
};

export default MedicinesEmpty;
